import React from 'react';
import '../styles/globals.css';
import '../styles/HeroSection.css';
import Fade from 'react-reveal/Fade';
import hero1 from '../img/stud-labs-banner.jpg'

function HeroSection() {
  return (
    <div className='hero-container' id='top'>
      <div className="scene"><img src={hero1} alt='hero' className='heroImg'/></div>
    </div>
  );
}

export default HeroSection;
